function accountNavInit() {
  const mobileNavToggle = document.querySelector('[data-account-mobile-nav-toggle]');
  const mobileNavMenu = document.querySelector('[data-account-mobile-nav]');

  mobileNavToggle.addEventListener('click', () => {
    mobileNavToggle.setAttribute('aria-expanded', !mobileNavMenu.getAttribute('aria-expanded'));
    mobileNavMenu.classList.toggle('active');
  });
}

document.addEventListener('DOMContentLoaded', () => {
  accountNavInit();
});


function accountOrdersInit() {
  const orders = document.querySelectorAll('[data-order]');

  orders.forEach(order => {
    const detailsToggle = order.querySelector('[data-order-details-toggle]');
    const details = order.querySelector('[data-order-details]');
    const orderAgainBtns = order.querySelectorAll('[data-reorder-btn]');

    detailsToggle.addEventListener('click', () => {
      detailsToggle.classList.add('active');
      details.classList.remove('hide');
    });

    orderAgainBtns.forEach(orderAgainBtn => {
      orderAgainBtn.addEventListener('click', async (event) => {
        event.preventDefault();

        const orderItemsJsonEl = order.querySelector('[data-order-item-json]');
        const orderItemsData = JSON.parse(orderItemsJsonEl.innerHTML);
        const currentText = orderAgainBtn.textContent;

        const addData = orderItemsData.reduce((object, item) => {
          const addItem = {
            id: item.variant_id,
            quantity: item.quantity,
            properties: {
              ...Object.fromEntries(item.properties),
              Reorder: true,
              Original_Order_ID: order.dataset.id
            },
          };

          object.items.push(addItem);
          return object;
        }, {items: []});

        orderAgainBtn.textContent = 'Adding...';

        const cartRes = await ajaxCartPost({action: 'add', data: addData});

        if (cartRes === 404 || cartRes === 422) {
          window.location.href = `/pages/contact-us/?order-id=${order.dataset.id}`;
        } else {
          window.location.href = '/cart';
        }

        orderAgainBtn.textContent = currentText;
      });
    });
  });
}

async function ajaxCartPost({action = 'change', data}) {
  const cartRes = await fetch(`/cart/${action}.js`, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'xmlhttprequest',
    },
    body: JSON.stringify(data),
  });

  if (!cartRes) {
    return Promise.reject(new Error('No response from Bold servers.'))
  }

  if (!cartRes.ok) {
    const errorBody = await cartRes.json();
    if (errorBody) { console.log({errorBody}); }

    return cartRes.status;
  }

  //  return promise parsing function
  return cartRes.json();
}

document.addEventListener('DOMContentLoaded', () => {
  accountOrdersInit();
});

function accountFeaturedProductsInit() {
  const featuredProductsEl = document.querySelector('[data-account-featured-products]');

  if (!featuredProductsEl) {
    return;
  }

  const featuredProductsSlider = featuredProductsEl.querySelector('[data-account-featured-products-slider]')
  const prevBtn = featuredProductsEl.querySelector('[data-account-featured-products-nav="prev"]');
  const nextBtn = featuredProductsEl.querySelector('[data-account-featured-products-nav="next"]');
  const mobileMq = window.matchMedia('(max-width: 750px)');
  let swiper = null;

  mobileMq.onchange = (event) => {
    if (event.matches) {
      swiper = initSwiper(featuredProductsSlider);
    } else {
      swiper.destroy();
    }
  };

  if (mobileMq.matches) {
    initSwiper(featuredProductsSlider);
  }

  function initSwiper(sliderContainer) {
    const options = {
      slidesPerView: 'auto',
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
    };

    return new Swiper(sliderContainer, options);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  accountFeaturedProductsInit();
});